import React from 'react';

import { RecommendedJobsBlockData } from 'api/cms';

import { AmpCmsRecommendedJobs } from './Amp';
import { StandardCmsRecommendedJobs } from './Standard';

type Props = {
  data: RecommendedJobsBlockData;
  source: 'RECOMMENDED_JOBS_CHECKBOX' | 'RECOMMENDED_JOBS_BLOCK';
  context: 'amp' | 'standard';
};

export function RecommendedJobsBlockContent({
  data: { headline, layout, jobFunction },
  source,
  context,
}: Props) {
  if (context === 'amp') {
    return (
      <AmpCmsRecommendedJobs
        headline={headline}
        layout={layout}
        jobFunction={jobFunction}
        source={source}
      />
    );
  }

  return (
    <StandardCmsRecommendedJobs
      headline={headline}
      layout={layout}
      jobFunction={jobFunction}
      source={source}
    />
  );
}
